<template>
  <div class="blog-block blog-video">
    <div class="blog-video__inner" v-html="data.video"></div>

    <div
      class="blog-video__poster"
      v-if="!hiddenPoster"
      :style="{ backgroundImage: `url('${data.poster}')` }" @click="hide"
    >
      <div class="blog-video__poster-play">
        <div class="blog-video__poster-play-icon"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'blog-video',

  props: ['data'],

  data() {
    return {
      hiddenPoster: false,
    };
  },

  methods: {
    hide() {
      this.hiddenPoster = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.blog-video {
  position: relative;

  &__inner {
    width: 100%;
    height: calc(675px * var(--rw));
    overflow: hidden;

    ::v-deep iframe {
      width: 100%;
      height: 100%;
      margin: 0 auto;
    }
  }

  &__poster {
    position: absolute;
    width: 100%;
    height: calc(675px * var(--rw));
    left: 0px;
    top: 0px;

    background-position: center center;
    background-size: cover;

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;

    &-play {
      width: calc(120px * var(--rw));
      height: calc(120px * var(--rw));
      border-radius: 100%;
      background-color: $color-white;

      display: flex;
      align-items: center;
      justify-content: center;

      &-icon {
        width: calc(23px * var(--rw));
        height: calc(32px * var(--rw));

        background-image: url('/static/vector/triangle-right.svg');
        background-position: center center;
        background-size: contain;
        background-repeat: no-repeat;
      }
    }
  }
}
</style>
